import WOW from 'wow.js';

let wow = new WOW({
    boxClass:     'animated',      // default
    animateClass: 'animated', // default
    offset:       0,          // default
    mobile:       false,       // default
    live:         false        // default
});

wow.init();


// WEBPACK FOOTER //
// ./scripts/util/animate.js